export const LOGGED_IN_SIGNUP_STEPS_UK = [
  'business',
  'check-eligibility',
  'applicant',
  'offers',
  'check',
  'check-skipped',
  'documents',
  'decision',
] as const;

export const LOGGED_IN_SIGNUP_STEPS_DE = [
  'schritt-1',
  'schritt-2',
  'schritt-3',
  'angebote',
  'eignungscheck',
] as const;

const LOGGED_IN_SIGNUP_DIRECT_STEPS_UK = [
  'business',
  'company-questions', // New AI split test route
  'check-eligibility',
  'applicant',
  'offers',
  'check',
  'documents',
] as const;

export const SIGNUP_STEPS_DIRECT_UK = [
  '',
  'new',
  ...LOGGED_IN_SIGNUP_DIRECT_STEPS_UK,
] as const;

export const SIGNUP_STEPS_PARTNER_UK = [
  '',
  'new',
  ...LOGGED_IN_SIGNUP_STEPS_UK,
] as const;

export const DE_ENTRY_STEP = 'neu';

export const SIGNUP_STEPS_DE = [
  '',
  DE_ENTRY_STEP,
  ...LOGGED_IN_SIGNUP_STEPS_DE,
] as const;

export const UK_DIRECT_BASE_PATHNAME = 'apply';
export const DE_DIRECT_BASE_PATHNAME = 'kreditwunsch';
export const UK_DIRECT_BASE_OB_LINK_PATHNAME = 'link-open-banking';
export const UK_PREVIEW_LINK_BANK_PATHNAME = 'preview-link-bank';

// The Introducer Portal (TIP) is served from the same origin as signup, under
// /introducer/portal (UK) and /partner/portal (DE) — see introducer-portal's
// getBasename(). Brokers who land on the customer signup are sent back here.
export const TIP_PORTAL_PATH_UK = '/introducer/portal/';
export const TIP_PORTAL_PATH_DE = '/partner/portal/';

export const IWOCA_AFFILIATE_TAG = 'iwoca';

export const DIRECTOR_DATA_REQUIREMENT_ERRORS = [
  'check_directors_match_companies_house',
  'check_director_as_applicant',
  'check_director_as_guarantor',
];

export const CREDIT_DATA_REQUIREMENT_ERRORS = [
  'complete_personal_credit_check',
  'complete_additional_personal_credit_check',
];

export const SELF_SERVE_DATA_REQUIREMENT_ERRORS = [
  // Director errors, I think all 3 errors will normally happen together
  ...DIRECTOR_DATA_REQUIREMENT_ERRORS,
  // Missmatching info, normally address isn't a match
  // Errors from the director will often cause this too
  ...CREDIT_DATA_REQUIREMENT_ERRORS,
];

// Server-assigned split tests keyed by experiment name. Most are fetched
// individually via the isolated split-test endpoint (see useSplitTestBranch,
// which types its argument as TIsolatedSplitTests). PARTNER_DECISION_PAGE_
// COST_FRAMING_2026 is instead read from /context (it's exposed there), so it's
// a slight outlier to this grouping; there's no dedicated "context split tests"
// map today, so it lives here alongside its peers rather than adding a
// single-member constant.
export const ISOLATED_SPLIT_TESTS = {
  PARTNER_DECISION_PAGE_COST_FRAMING_2026:
    'partner_decision_page_cost_framing_2026',
  REMOVE_VAT_REQUIREMENT_TEST: 'remove_vat_requirement_test',
  SIGNUP_NO_PG_TEST: 'signup_no_pg_test',
  DE_OPEN_BANKING_COPY_TEST: 'de_open_banking_copy_test_2026_q1',
  DE_COMPANY_SEARCH_UI_TEST: 'de_company_search_ui_test_2026_q1',
  DE_6M_PDF_BS_TEST: 'de_6m_pdf_bs_test_2026_q2',
  DE_EXIT_POLL_TEST: 'de_exit_poll_test_2026_q3',
  DE_REPAYMENT_REDUCTION_TEST: 'de_repayment_reduction_test_2025',
} as const;

export const EMPTY_ADDRESS = {
  houseNumber: '',
  houseName: '',
  streetLine1: '',
  streetLine2: '',
  town: '',
  postcode: '',
  equifaxToken: '',
};
